"use strict";

function dataSkills(problematics) {
  var input = $('#competences');
} // Close Skill block


(function ($) {
  $.fn.closeSkill = function () {
    var that = this,
        close = $(this).find('.js-close');
    close.on('click', function () {
      var block = $(this).parent();
      var inputs = block.find('.js-problematic');
      inputs.prop('checked', false);
      block.remove();
    });
  };
})(jQuery);

(function ($) {
  $.fn.skillCheckboxes = function () {
    var that = $(this);
    that.on('change', function () {
      var checked = $(this).prop('checked'),
          link_problematics = $(this).closest('.js-skill-block').find('.js-problematic');

      if (checked == false) {
        link_problematics.prop('checked', false);
      } else {
        link_problematics.prop('checked', true);
      }
    });
  };
})(jQuery);

(function ($) {
  $.fn.lawyerProblematics = function () {
    var problematics = $('.js-lawyer-problematic');
    var arrProb = [];
    problematics.each(function () {
      arrProb.push($(this).attr('id'));
    });

    for (var i = 0; i < arrProb.length; i++) {
      $('.js-problematic').each(function () {
        if ($(this).attr('id') == arrProb[i]) {
          $(this).prop('checked', true);
        }
      });
    }
  };
})(jQuery);

(function ($) {
  $.fn.toggleSkill = function () {
    var that = $(this);
    $(this).on('click', function () {
      var block = $(this).parent().parent();
      block.toggleClass('hidden-content');
    });
  };
})(jQuery);